import React,{Component} from 'react';
import "./header/Header.css" 
import "../scss/general.css"
import "react-datepicker/dist/react-datepicker.css";
import 'react-month-picker-dropdown/dist/index.css'; 
import '../scss/green-theme.css';
import logo from "./images/loading.gif";
import Cookies from "universal-cookie";
import Mymodal from './modal';
import config from '../config';
const cookies = new Cookies();
const axios = require("axios");
const ref = React.createRef();
export default class AdminLE extends Component{
    constructor(props)
    {
        super(props);
        this.state=
        { 
            input:{},
            myitems:[],
            leavedata:{},
            tLeave:0,
            isLoaded: true,
            isForm: "none",
            isData: false,
            EmpID:"",
            LE_days:0.0,
            TLE_days:0,
            Period:0,
            P_days:0,
            savetext:"",
            errorcss:"labelsave",
            AnnualBalance:0,
            apipath:"",
            ErrMsg:<img src={logo} alt=""/>
        }
        this.handleFocus = this.handleFocus.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputLE = this.handleInputLE.bind(this);        
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleLostFocus=this.handleLostFocus.bind(this);
        this.handleSave=this.handleSave.bind(this);
        this.maxLengthCheck=this.maxLengthCheck.bind(this);
    }
    componentDidMount(){
        this.setState({apipath:this.props.apipath});
    }
    maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
          }
    }
    handleLostFocus() 
    {
        let ledays=this.state.LE_days;
        if (ledays > 0 && ledays <= this.state.AnnualBalance)
            this.setState({LE_days: this.cur(ledays)});
        else
            this.setState({savetext:"Check the available balance."})
    }
    cur(num) 
    {
        if(typeof num === "undefined"){num=0;}
        let cnum=parseInt(num, 0);
        if(cnum !== 0)
            return  num.toFixed(1); //.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        else
            return "-"
    }
    handleInputChange = (e)=> {  
      this.setState({EmpID: e.target.value});
    }
    handleInputChangePeriod = (e)=> {  
        this.setState({Period: e.target.value});
    }
    handleInputLE = (e)=> {
        let leavedata=this.state.leavedata;
        leavedata["TAnnual"]=Number(leavedata["BFAnnual"])+Number(leavedata["Annual"])-Number(e.target.value)-Number(leavedata["LAnnual"]);
        leavedata["EAnnual"]=Number(e.target.value);
        this.setState({LE_days: e.target.value, leavedata});
    }
    handleFocus(event)
    {
        event.target.select();
        this.setState({P_days:event.target.value});
    }

    handleSave()
    {
        let input=this.state.input;
        input["LE_days"]=this.state.LE_days;
        input["Period"] = this.state.Period;
        input["ID"] = this.state.EmpID;
        this.setState(input);
        document.body.style.cursor="wait";
        console.log(this.state.input);
        axios({
                method: 'post',
//                url: cookies.get("phpclass")+'/index.php/user/SetLeaveEncash/',
                url: this.state.apipath+'/index.php/user/SetLeaveEncash/',
                data: this.state.input,
                headers: {'Content-Type': 'multipart/form-data'}
            })
            .then((response)=> {
                console.log(response.data);
                if(response.data.length == 1)
                {
                    this.setState({savetext:"Failed to save. Try later",errorcss:"labelerror"});
                    document.body.style.cursor="default";
                }
                else
                {
                    this.setState({savetext:"Saved Successfully",errorcss:"labelsave",input:{}});
                    document.body.style.cursor="default";
                }
        })
        .catch((response)=> {
            document.body.style.cursor="default";
            this.setState({ErrMsg:<Mymodal Type="1" Title={config.gvr.ErrMsgs.TitleNotFound} Body={config.gvr.ErrMsgs.MsgNotFound}/>});
        });     
    }

    handleSubmit()
    {
        this.setState({errortext:"",errorcss:"labelerror"});
        if(this.state.EmpID.length < 6)
        {  
            this.setState({errortext:"Invalid employee id",errorcss:"labelerror"});
        }
        else
        {        
          document.body.style.cursor="wait";
          let input=this.state.input;
          input["ID"]=this.state.EmpID;
          input["LE_days"]=this.state.LE_days;
          input["Period"] = this.state.Period;
          this.setState({input, isLoaded: true});
          axios({
                method: 'post',
                url: this.state.apipath+'/index.php/user/leaveforencash/',
                data: this.state.input,
                headers: {'Content-Type': 'multipart/form-data'}
            })
            .then((response)=> {
                console.log(response.data);
                if(response.data.length == 0)
                {
                    this.setState({errortext:"Invalid employee id or Year",errorcss:"labelerror",isForm:"none"});
                    document.body.style.cursor="default";
                }
                else
                {
                    document.body.style.cursor="default";
                    let leavedata=this.state.leavedata;

                    leavedata["Name"]=response.data[0].NAME;
                    leavedata["Designation"]=response.data[0].DESIG;
                    leavedata["Location"]=response.data[0].LOCATION;

                    leavedata["BFAnnual"]=Number(response.data[0].BF_ANNUAL);
                    leavedata["BFCasual"]=0; 
                    leavedata["BFSick"]=0; 

                    leavedata["Annual"]=Number(response.data[0].ANNUAL);
                    leavedata["Casual"]=Number(response.data[0].CASUAL);
                    leavedata["Sick"]=Number(response.data[0].SICK);

                    leavedata["BAnnual"]=Number(response.data[0].ANNUAL)+Number(response.data[0].BF_ANNUAL);
                    leavedata["BCasual"]=Number(response.data[0].CASUAL);
                    leavedata["BSick"]=Number(response.data[0].SICK);

                    leavedata["EAnnual"]=Number(response.data[0].E_ANNUAL);
                    leavedata["ECasual"]=Number(response.data[0].E_CASUAL);
                    leavedata["ESick"]= Number(response.data[0].E_SICK);

                    leavedata["LAnnual"]=Number(response.data[0].L_ANNUAL);
                    leavedata["LCasual"]=Number(response.data[0].L_CASUAL);
                    leavedata["LSick"]=Number(response.data[0].L_SICK);
                    this.setState({tLeave:leavedata["LAnnual"]+leavedata["LCasual"]+leavedata["LSick"]});

                    leavedata["TAnnual"]=Number(response.data[0].BF_ANNUAL)+Number(response.data[0].ANNUAL)-Number(response.data[0].E_ANNUAL)-Number(response.data[0].L_ANNUAL);
                    leavedata["TCasual"]=Number(response.data[0].CASUAL)-Number(response.data[0].E_CASUAL)-Number(response.data[0].L_CASUAL);
                    leavedata["TSick"]=Number(response.data[0].SICK)-Number(response.data[0].E_SICK)-Number(response.data[0].L_SICK);
                    this.setState({AnnualBalance:Number(response.data[0].BF_ANNUAL)+Number(response.data[0].ANNUAL)-Number(response.data[0].L_ANNUAL)});

                    this.setState({leavedata,isLoaded: true,isForm:"block", myitems: response.data,tLeave:1,LE_days: Number(response.data[0].E_ANNUAL),TLE_days:leavedata["TAnnual"]});
                }
            })
            .catch((response)=> {
                document.body.style.cursor="default";
                this.setState({isForm:"none",ErrMsg:<Mymodal Type="1" Title={config.gvr.ErrMsgs.TitleNotFound} Body={config.gvr.ErrMsgs.MsgNotFound}/>});
            });  
      }
    }
    render()
    {
      let isLoaded = this.state.isLoaded;
      let items = this.state.myitems;
      let isForm = this.state.isForm;
      if(isLoaded)
      {
        return( 
            <div style={{marginTop:"25px"}}>
            <div className="inner-profile33-all" >
            <div className="inner-profile2" >

                <br></br>
                <table className="csstable" >
                <tr>
                    <td  width="100px" align="right" padding="2px" >Employee ID:</td>
                    <td width="100px" padding="1px">
                        <input  
                            style={{width:100}}
                            autoFocus="autofocus"
                            name="empid"
		        	        placeholder="Employee Id"
                            onBlur={this.handleInputChange}
                            onFocus={ this.handleFocus}
                        />
                    </td>
                </tr>
                <tr>
                    <td width="100px" align="right" padding="2px" >For year:</td>
                        <td width="100px" padding="1px">
                            <input  type="number"
                                name="period"
                                style={{width:100}}
                                pattern="[0-9]+"
                                min="2001" 
                                max="2099" 
                                
                                minLength="4" maxLength="4"                                
                                autoFocus="autofocus"
		        	            placeholder="for year" 
                                onInput={this.maxLengthCheck}                                        
                                onBlur={this.handleInputChangePeriod}
                                onFocus={ this.handleFocus}
                            />
                        </td>
                        <td  align="right"  paddingTop="15px"  height="40px" width="50px" >
                            <button onClick={this.handleSubmit}  className="btn btn-secondary active">Submit</button>
                        </td>
                    </tr>
                <tr>
                    <td  width="100px" ></td>
                    <td colSpan="2" style={{width:"100px", paddingTop:"0px",fontSize:"10pt",align:"left"}}>
                        <span className={this.state.errorcss}> {this.state.errortext}</span>
                    </td>
                </tr>
        </table>
        </div>
        <div width="100%"  >  

{/*}            <div className="inner-profile" style={{display:isForm}} >*/}
                <div style={{ width:"80%", left:"30%", margin:"0 auto",display:isForm}} id="DReport" name="DReport"  ref={ref}>
{/*}                        <span style={{width:"100%",textAlign:"center",marginTop:"20px"}}>
                        <h5 >Leave Balances & Details</h5>
                        <span style={{float:"left"}}>
                        </span>*/}
                        <div  style={{width:"100%",align:"center"}}  >

                        <table style={{width:"700px",marginTop:"20px"}}>
                        <thead></thead>
                        <tbody>
                            <tr>
                                <td style={{width:"100px",border:"none"}}>Name:</td>
                                <td style={{width:"250px",border:"none"}}>{this.state.leavedata['Name']}</td>
                            </tr>
                            <tr>
                                <td style={{width:"100px",border:"none"}}>Designation:</td>
                                <td style={{width:"250px",border:"none"}}>{this.state.leavedata['Designation']}</td>
                            </tr>
                            <tr>
                                <td style={{width:"100px",border:"none"}}>Location:</td>
                                <td style={{width:"250px",border:"none"}}>{this.state.leavedata['Location']}</td>
                            </tr>
                        </tbody>
                        </table>
{/*}                        </span>*/}
                            {/*<h6>{Moment(this.state.fromDate).format("DD/MM/YYYY")} - {Moment(this.state.toDate).format("DD/MM/YYYY")}</h6>*/}

                        <table width="100%" margin="auto">
                            <thead>
                                <tr className="tr">
                                    <th className="th" scope="col"></th>
                                    <th className="th" scope="col">ANNUAL</th>
                                    <th className="th" scope="col">CASUAL</th>
                                    <th className="th" scope="col">SICK</th>
                                    <th className="th" scope="col">TOTAL</th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td className="tddesc" >Balance B/F</td>
                                <td className="tdamb" >{this.cur(this.state.leavedata["BFAnnual"])}</td>
                                <td className="tdamb" >{this.cur(this.state.leavedata["BFCasual"])}</td>
                                <td className="tdamb" >{this.cur(this.state.leavedata["BFSick"])}</td>
                                <td className="tdamb" >{this.cur(Number(this.state.leavedata["BFSick"])+Number(this.state.leavedata["BFCasual"])+Number(this.state.leavedata["BFAnnual"]))}</td>
                            </tr>
                            <tr>
                                <td className="tddesc" >This year</td>
                                <td className="tdamb" >{this.cur(this.state.leavedata["Annual"])}</td>
                                <td className="tdamb" >{this.cur(this.state.leavedata["Casual"])}</td>
                                <td className="tdamb" >{this.cur(this.state.leavedata["Sick"])}</td>
                                <td className="tdamb" >{this.cur(Number(this.state.leavedata["Sick"])+Number(this.state.leavedata["Casual"])+Number(this.state.leavedata["Annual"]))}</td>
                            </tr>
                            <tr>
                                <td className="tdhead" ><b>Balance</b></td>
                                <td className="tdambhead" >{this.cur(this.state.leavedata["BAnnual"])}</td>
                                <td className="tdambhead" >{this.cur(this.state.leavedata["BCasual"])}</td>
                                <td className="tdambhead" >{this.cur(this.state.leavedata["BSick"])}</td>
                                <td className="tdambhead" >{this.cur(Number(this.state.leavedata["BSick"])+Number(this.state.leavedata["BCasual"])+Number(this.state.leavedata["BAnnual"]))}</td>
                            </tr>
                            <tr>
                                <td className="tddesc" >Leave Encashed</td>
                                <td className="tdamb" >
{/*}                                <input type="date" ></input>*/}
                                <input type="number" style={{width:65, textAlign: 'right' }}
                                    name="LE_days"
                                    value={(this.state.LE_days)}                                                
                                    onChange={e=> this.handleInputLE(e)}
                                    onFocus={ this.handleFocus}
                                    onBlur={this.handleLostFocus}
                                />
                                </td>
                                <td className="tdamb" >{this.cur(this.state.leavedata["ECasual"])}</td>
                                <td className="tdamb" >{this.cur(this.state.leavedata["ESick"])}</td>
                                <td className="tdamb" >{this.cur(Number(this.state.leavedata["ESick"])+Number(this.state.leavedata["ECasual"])+Number(this.state.leavedata["EAnnual"]))}</td>
                            </tr>
                            <tr>
                                <td className="tddesc" >Leaves</td>
                                <td className="tdamb" >{this.cur(this.state.leavedata["LAnnual"])}</td>
                                <td className="tdamb" >{this.cur(this.state.leavedata["LCasual"])}</td>
                                <td className="tdamb" >{this.cur(this.state.leavedata["LSick"])}</td>
                                <td className="tdamb" >{this.cur(Number(this.state.leavedata["LSick"])+Number(this.state.leavedata["LCasual"])+Number(this.state.leavedata["LAnnual"]))}</td>
                            </tr>
                            <tr>
                                <td className="tdhead" ><b>Balance C/F</b> </td>
                                <td className="tdambhead" >{this.cur(this.state.leavedata["TAnnual"])}</td>
                                <td className="tdambhead" >{this.cur(this.state.leavedata["TCasual"])}</td>
                                <td className="tdambhead" >{this.cur(this.state.leavedata["TSick"])}</td>
                                <td className="tdambhead" >{this.cur(Number(this.state.leavedata["TSick"])+Number(this.state.leavedata["TCasual"])+Number(this.state.leavedata["TAnnual"]))}</td>
                            </tr>
                        </tbody>
                        </table>
                        <span className={this.state.errorcss}>{this.state.savetext}</span>
                        <br></br>
                        <div style={{width:"100%",textAlign:"center"}}>
                            <button onClick={this.handleSave} className="btn btn-secondary active">Save</button><br></br>
                        </div>
                    </div>
                </div>
{/*}             </div>*/}
            </div>
            <br></br><br></br>
            </div>
            </div>

            );
        }
        else
        { 
            return(null);
        }
    }
}